






















































import { Component } from "vue-property-decorator"
import { UPDATE_USER_INFO } from "@/store/types/mutations"
import { NullableUserInfo } from "@/models"
import {
    SOCKET_ISCONNECTED,
    SOCKET_ISSUBSCRIBED,
    SOCKET_IS_DISPATCHER_CONNECTED,
    GET_IS_RESTARTING,
    HAS_USER_INFO,
} from "@/store/types/getters"
import {
    CLEAR_SMART_BOX_LIST,
    CLEAR_VENUE_LIST,
    CLEAR_SELECTED_VENUE,
    CLEAR_MARKET_LIST,
    CLEAR_SELECTED_MARKET,
    CLEAR_SELECTED_SMART_BOX_LIST,
    CLEAR_OPERATION_LOG_LIST,
    CLEAR_FUZZY_SEARCH_RESULT_MAP,
    CLEAR_FUZZY_SEARCH_PARAMETER,
} from "@/store/types/mutations"
import { restartService } from "@/store/types/actions"
import ConstMixin from "@/mixins/const"
import { Getter, Mutation, Action } from "vuex-class"
import { mixins } from "vue-class-component"
import { VenueModule, MarketModule, SmartBoxModule } from "@/consts"

@Component
export default class SHeader extends mixins(ConstMixin) {
    @Getter(SOCKET_ISCONNECTED) private socket_isconnected!: boolean
    @Getter(SOCKET_ISSUBSCRIBED) private socket_issubscribed!: boolean
    @Getter(SOCKET_IS_DISPATCHER_CONNECTED)
    private socket_is_dispatcher_connected!: boolean
    @Getter(HAS_USER_INFO) private hasUserInfo!: boolean
    @Getter(GET_IS_RESTARTING) private isRestarting!: boolean
    @Mutation(UPDATE_USER_INFO) private updateUserInfo!: (
        newUserInfo: NullableUserInfo
    ) => void
    @Action(restartService) private restartService!: () => Promise<void>

    @VenueModule.Mutation(CLEAR_VENUE_LIST) private clearVenueList!: () => void
    @VenueModule.Mutation(CLEAR_SELECTED_VENUE)
    private clearSelectedVenue!: () => void
    @SmartBoxModule.Mutation(CLEAR_SMART_BOX_LIST)
    private clearSmartBoxList!: () => void
    @SmartBoxModule.Mutation(CLEAR_SELECTED_SMART_BOX_LIST)
    private clearSelectedSmartBoxList!: () => void
    @SmartBoxModule.Mutation(CLEAR_OPERATION_LOG_LIST)
    private clearOperationLogList!: () => void
    @SmartBoxModule.Mutation(CLEAR_FUZZY_SEARCH_RESULT_MAP)
    private clearFuzzySearchResultMap!: () => void
    @SmartBoxModule.Mutation(CLEAR_FUZZY_SEARCH_PARAMETER)
    private clearFuzzySearchParameter!: () => void
    @MarketModule.Mutation(CLEAR_MARKET_LIST)
    private clearMarketList!: () => void
    @MarketModule.Mutation(CLEAR_SELECTED_MARKET)
    private clearSelectedMarket!: () => void

    private get restartBtnTooltip() {
        return "restart the service"
    }

    private get isRestartBtnShow() {
        return (this as any).$UAcsLogin.hasRole("manager")
    }

    private get socketType() {
        return this.socket_isconnected && this.socket_issubscribed
            ? "is-success"
            : "is-danger"
    }

    private get socketStatus() {
        return this.socket_isconnected && this.socket_issubscribed
            ? "websocket is connected"
            : "websocket is disconnected"
    }

    private get dispatcherSocketStatus() {
        return this.socket_is_dispatcher_connected
            ? "dispatcher is connected"
            : "dispatcher is disconnected"
    }

    private ON_SIGN_IN() {
        this.$router.push({ name: "Dashboard" })
    }

    private ON_SIGN_OUT() {
        this.clearFuzzySearchParameter()
        this.clearFuzzySearchResultMap()
        this.clearSelectedSmartBoxList()
        this.clearSmartBoxList()
        this.clearOperationLogList()
        this.clearVenueList()
        this.clearSelectedVenue()
        this.clearMarketList()
        this.clearSelectedMarket()
        this.$router.push({ name: "Login" })
    }
}
